import axios from "axios";
import { errorModel } from "../context/model";
// Ensure the correct path to AppInsightsProvider is used
import { appInsights } from "../provider/InitializeTelemetryService";
import { REACT_APP_WUCA_DXP_ADMIN_URL, REACT_APP_WUCA_DXP_API_BEARER_TOKEN } from "./config";

interface logModel {
  type: string;
  source: string;
  eventCode: string;
  eventDescription: string;
  userName: string;
}

interface Logger {
  logToApi: (error: errorModel, silentTokenAcquireHook?: () => Promise<boolean>) => Promise<void>;
  logToAppInsights: (error: Error, severityLevel: number) => void;
}

export const logger: Logger = {
  logToApi: async (error: errorModel, silentTokenAcquireHook?: () => Promise<boolean>) => {
    const MAX_RELOGIN_ATTEMPTS = 2;
    let reloginAttempts = 0;

    const authToken = sessionStorage.getItem("authToken");
    const userName = sessionStorage.getItem("nameOfUser") || "Portal User";

    if (!authToken) {
      console.info("No authentication token found for logging API");
      return;
    }

    const logModel: logModel = {
      type: error.type,
      source: error.source,
      eventCode: error.eventCode,
      eventDescription: error.error,
      userName: userName,
    };

    const queryParams = new URLSearchParams({
      type: logModel.type,
      source: logModel.source,
      eventCode: logModel.eventCode,
      eventDescription: logModel.eventDescription,
      userName: logModel.userName,
    });

    const apiUrl = `${REACT_APP_WUCA_DXP_ADMIN_URL}api/v1/logging?${queryParams.toString()}`;

    const makeRequest = async (token: string): Promise<void> => {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-API-KEY": REACT_APP_WUCA_DXP_API_BEARER_TOKEN,
          accept: "text/plain",
        },
      });
      // console.log("Log API response:", response.data);
    };

    try {
      await makeRequest(authToken);
      reloginAttempts = 0; // Reset on success
    } catch (apiError: any) {
      console.info("Error in logging API:", apiError);
      if (
        (apiError?.response?.status === 401 || apiError?.response?.status === 403) &&
        reloginAttempts < MAX_RELOGIN_ATTEMPTS &&
        silentTokenAcquireHook
      ) {
        reloginAttempts++;
        const isReLogined = await silentTokenAcquireHook();
        // console.log("Re-login status:", isReLogined);
        
        if (isReLogined) {
          console.log("Re-login successful, retrying logToApi");
          // Retry with new token
          try {
            const newToken = sessionStorage.getItem("authToken") || "";
            await makeRequest(newToken);
            reloginAttempts = 0; // Reset on success
          } catch (retryError) {
            reloginAttempts = 0; // Reset on other errors
            console.error("There was an error making the request from logApi after re-login!", retryError);
          }
        }
      } else {
        reloginAttempts = 0; // Reset on other errors
        console.info("There was an error making the request from logApi!", apiError);
      }
    }
  },
  logToAppInsights: (error: Error, severityLevel: number) => {
    appInsights.trackException({
      exception: error,
      severityLevel: severityLevel,
    });
  },
};
